export default __webpack_public_path__ + "4379e23009bb74e08fab9bccef210d57.svg";